var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFileTxt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#939393",
    points: "44,27 4,27 1,23 5,19 43,19 47,23 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M41,47H7c-1.105,0-2-0.895-2-2V3c0-1.105,0.895-2,2-2l24,0l12,12v32C43,46.105,42.105,47,41,47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3B3B3",
    d: "M31,1v10c0,1.105,0.895,2,2,2h10L31,1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3B3B3",
    d: "M45,41H3c-1.105,0-2-0.895-2-2V23h46v16C47,40.105,46.105,41,45,41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M17.836,36h-2.121v-6.117h-1.918v-1.735h5.951v1.735h-1.912V36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M27.945,36H25.49l-1.531-2.455L22.445,36h-2.401l2.604-4.018l-2.449-3.835h2.354l1.418,2.428l1.363-2.428 h2.423l-2.487,4.001L27.945,36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M32.29,36h-2.122v-6.117h-1.917v-1.735h5.951v1.735H32.29V36z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileTxt);
export default __webpack_public_path__ + "static/media/icon-file-txt.f6e3134416406e4ad1f8368b630e8bec.svg";
export { ForwardRef as ReactComponent };